import {request} from "./request";

// 获取列表
export function getListData(type,params) {
  return request({
    url:`api_v1/${type}/getList`,
    method:'GET',
    params:{
      page:params.page,
      list_rows: params.list_rows,
      cate_id: params.cate_id
    }
  })
}

// 获取新闻详情
export function getInfoData(type,id) {
  return request({
    url:`api_v1/${type}/getInfo`,
    method:'GET',
    params:{
      id:id
    }
  })
}

// 获取分类详情
export function getCateInfoData(type,cate_id) {
  return request({
    url:`api_v1/${type}/getCateToInfo`,
    method:'GET',
    params:{
      cate_id: cate_id
    }
  })
}

// 获取搜索结果
export function getSearchData(params) {
  return request({
    url:`api_v1/Home/getSearchData`,
    method:'GET',
    params:{
      page:params.page,
      list_rows: params.list_rows,
      search_data: params.search_data
    }
  })
}








